import { find, get } from "lodash";
import React from "react";
import { DragDropContext } from "react-beautiful-dnd";
import { Container, Column } from "../styles";
import { VirtualizedColumn } from "./VirtualizedColumn";
import styled from 'styled-components';
import { Skeleton, message } from 'antd';

const SkeletonColumn = styled.div`
  width: 300px;
  margin: 0 8px;
  padding: 16px;
  background: #f5f5f5;
  border-radius: 4px;
`;

const SkeletonCard = styled.div`
  margin-bottom: 16px;
  padding: 16px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
`;

const SkeletonContainer = styled.div`
  display: flex;
  padding: 16px;
  overflow-x: auto;
`;

const LeadColumnsSkeleton = () => (
  <SkeletonContainer>
    {[1, 2, 3, 4, 5].map((column) => (
      <SkeletonColumn key={column}>
        <Skeleton active paragraph={{ rows: 0 }} />
        {[1, 2, 3, 4, 5].map((card) => (
          <SkeletonCard key={card}>
            <Skeleton active paragraph={{ rows: 2 }} />
          </SkeletonCard>
        ))}
      </SkeletonColumn>
    ))}
  </SkeletonContainer>
);

export const LeadColumns = ({
  columns,
  moveLead,
  date,
  loadMoreLeads,
  isLoading,
  showDrawer,
}) => {
  if (isLoading) {
    return <LeadColumnsSkeleton />;
  }

  const getColumnData = (column) => {
    return column.data || [];
  };

  const getColumnCount = (column) => {
    return column.data.length || 0;
  };

  // Show warning when users try to drag leads
  const onDragStart = () => {
    message.warning('Para mover para outra coluna, clique no lead e avance a cadência.');
  };

  // Disabled drag and drop functionality
  const onDragEnd = async (result) => {
    // Do nothing - drag and drop is disabled
    return;
  };

  const activeColumns = columns.filter((column) => get(column, 'hidden', false) === false);

  return (
    <Container>
      <DragDropContext onDragStart={onDragStart} onDragEnd={onDragEnd}>
        {activeColumns.map((column) => {
          const data = getColumnData(column);
          const count = getColumnCount(column);

          return (
            <Column key={column.id}>
              <VirtualizedColumn
                column={column}
                data={data}
                count={count}
                isLoading={isLoading}
                showDrawer={showDrawer}
              />
            </Column>
          );
        })}
      </DragDropContext>
    </Container>
  );
};
